import React from 'react';
import { formatMMtoHHMM } from '@mummssoftware/utils/formatters';
import { Refused } from '@mummssoftware/utils/frequencies/frequency-constants';
import parse from 'html-react-parser';
import { VisitDetailDiv, TaskSpan } from './WrapperDiv';
import { HCPCSTable } from './HCPCSTable';
import { defaults } from './en';
export const patientMeasureMapper = patientMeasures => `${patientMeasures.map(measure => `${measure.typeshortname}: ${measure.typeshortname === 'bp' && measure.displayvalue || measure.typeshortname === 'fast' && measure.enteredvalue || measure.value}${measure.units === '0-100' && '/100' || measure.units === '%' && '%' || measure.units === '1-7f' && ' ' || measure.units && ` ${measure.units}` || ''}`).join(', ')}`;
export const patientTaskMapper = patientTasks => patientTasks.map((task, i) => /*#__PURE__*/React.createElement(TaskSpan, {
  refused: task.actiontaken.toLowerCase() === Refused.toLowerCase() // eslint-disable-next-line react/no-array-index-key
  ,
  key: `${task.patientvisit_id}-${i}`
}, task.tasktext, i === patientTasks.length - 1 ? '' : ', '));
export const patientHCPCSMapper = patienthcpcs => /*#__PURE__*/React.createElement(HCPCSTable, {
  data: patienthcpcs
});
/** Compact HCPCS: codes only, e.g. "99232" or "99232,99235". */

export const patientHCPCSSummaryMapper = patienthcpcs => Array.isArray(patienthcpcs) ? patienthcpcs // pimreader uses `code`; live/saved DTO uses `hcpcsCode`
.map(item => (item === null || item === void 0 ? void 0 : item.hcpcsCode) || (item === null || item === void 0 ? void 0 : item.code)).filter(Boolean).join(',') : '';
export const travelTimeMapper = durationmins => {
  if (durationmins === null || durationmins === undefined || durationmins === '') {
    return '';
  }

  if (durationmins === defaults.travelTimeInProgress) {
    return durationmins;
  }

  return `${formatMMtoHHMM(Number(durationmins))}`;
};
export const patientProgressNoteMapper = patientProgressNotes => patientProgressNotes.slice(-1).map((note, index) => {
  // cut out review text appended to progress note unless the note itself is from a review
  const noteText = note.note;
  const reviewMarker = '****';
  const filteredNote = noteText.startsWith(reviewMarker) ? noteText : noteText.split(reviewMarker)[0];
  return /*#__PURE__*/React.createElement(VisitDetailDiv, {
    key: `${note.id}`
  }, `${index === 0 && '' || '- '}`, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, parse(filteredNote)));
});
export const patientAttributeMapper = attributes => {
  if (!attributes || !attributes[0]) return; // eslint-disable-next-line consistent-return

  return `${attributes.map(att => att.name).join(', ')}`;
};
export const summaryMapper = dto => Array.isArray(dto) && dto.length;
export const durationMinsMapper = durationmins => formatMMtoHHMM(durationmins);